<template>
  <div class="listing-dashboard-container lister-branding">
    <div class="listings-dashboard-nav">
      <div class="tabbed-nav-container">
        <div class="tabbed-nav" :class="{active: activeNav == 'in-review'}" @click="activeNav = 'in-review'">In Review</div>
        <div class="tabbed-nav" :class="{active: activeNav == 'active'}" @click="activeNav = 'active'">Active</div>
        <div class="tabbed-nav" :class="{active: activeNav == 'rejected'}" @click="activeNav = 'rejected'">Rejected</div>
      </div>
      <div class="listings-dashboard-layout mobile-break">
        <div class="action">
          <button type="button" class="button primary uc" :class="{current: mode === 'grid', 'outline-black': mode !== 'grid'}" @click="mode = 'grid'">
            Grid
          </button>
        </div>
        <div class="action">
          <button type="button" class="button primary uc" :class="{current: mode === 'list', 'outline-black': mode !== 'list'}" @click="mode = 'list'">
            List
          </button>
        </div>
      </div>
    </div>

    <div class="resource-item-container loading" v-if="loading">
      <div class="data-loader">
        <div class="data-loader-inner">
          <div class="data-loader-icon">
            <svg-icon id="loading" class="spin"></svg-icon>
          </div>
          <div class="data-loader-message">Loading data...</div>
        </div>
      </div>
    </div>

    <template v-if="listings && listings.data">
      <div class="listing-card-container" v-if="mode == 'grid'">
        <listing-card
          v-for="listing in listings.data"
          :key="listing.id"
          :listing="listing"
        ></listing-card>
      </div>
      <div class="listing-list-container" v-else-if="mode == 'list'">
        <div class="listing-card-list-heading-container list-view-block">
          <div class="listing-card-list-heading">Property ID</div>
          <div class="listing-card-list-heading">Listing Name</div>
          <div class="listing-card-list-heading">Listing Address</div>
          <div class="listing-card-list-heading">Date Modified</div>
          <div class="listing-card-list-heading"></div>
        </div>
        <listing-list-view
          v-for="listing in listings.data"
          :key="`list-${listing.id}`"
          :listing="listing"
        ></listing-list-view>
      </div>
    </template>

    <div class="pagination mt-4" v-if="listings && listings.data && listings.data.length">
      <pagination
        :current-page="page"
        :total-pages="totalPages"
        @change-page="changePage"
      ></pagination>

      <div class="pagination-label">
        {{ listings.from }} - {{ listings.to }} of
        {{ listings.total }} spaces
      </div>
    </div>

    <div class="no-results" v-if="!loading && (!listings || !listings.data || listings.data.length == 0)">
      <p>There are no results to show here at this time.</p>
    </div>

  </div>
</template>

<script>
import ListingItem from '../../../../account/lister/panels/main/elements/Listing.vue';
import ListingCard from './ListingCard';
import ListingListView from './ListingListView';

export default {
  components: {
    ListingItem,
    ListingCard,
    ListingListView
  },

  data () {
    return {
      id: 'listings',
      mode: (localStorage['listingsViewMode']) ? localStorage['listingsViewMode'] : 'grid',
      activeNav: 'in-review',
      loading: false,
      listings: [],
      page: 1,
      totalPages: 1,
      perPage: 10
    }
  },

  computed: {},

  watch: {
    mode () {
      localStorage['listingsViewMode'] = this.mode
    },
    activeNav() {
      this.getListings();
    }
  },

  created () {
  },

  mounted () {
    this.getListings();
    this.$eventBus.$on(`update_listing_listing-item`, this.getListings)
  },

  methods: {
    changePage(which) {
      this.page = which;
      this.getListings();
    },
    getListings() {
      this.loading = true;
      let url;
      switch (this.activeNav) {
        case "in-review":
          url = `/api/account/listings/in-review?page=${this.page}`;
          break;
        case "active":
          url = `/api/account/listings?page=${this.page}`;
          break;
        case "rejected":
          url = `/api/account/listings/rejected?page=${this.page}`;
          break;
        default:
          break;
      }

      if(url) {
        axios.get(url).then((response) => {
          this.listings = response.data;
          this.totalPages = Math.ceil(response.data.total / this.perPage);
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      } else {
        this.loading = false;
      }
    }
  }
}
</script>
